var Item, _, assert, beginSerialization, beginSerializeItem, createItem, deserializeItems, dom, endSerialization, endSerializeItem, htmlparser, serializeItemBody;

htmlparser = require('htmlparser2');

assert = require('../util').assert;

_ = require('underscore-plus');

Item = require('../item');

dom = require('../dom');


/*
Serialization
 */

beginSerialization = function(items, options, context) {
  var bodyElement, headElement;
  context.opml = dom.createElement('opml', {
    version: '2.0'
  });
  context.elementStack = [];
  context.topElement = function() {
    return this.elementStack[this.elementStack.length - 1];
  };
  context.popElement = function() {
    return this.elementStack.pop();
  };
  context.pushElement = function(element) {
    return this.elementStack.push(element);
  };
  headElement = dom.createElement('head');
  bodyElement = dom.createElement('body');
  dom.appendChild(context.opml, headElement);
  dom.appendChild(context.opml, bodyElement);
  return context.pushElement(bodyElement);
};

beginSerializeItem = function(item, options, context) {
  var eachName, eachValue, i, len, outlineElement, parentElement, ref;
  parentElement = context.topElement();
  outlineElement = dom.createElement('outline', {
    id: item.id
  });
  ref = item.attributeNames;
  for (i = 0, len = ref.length; i < len; i++) {
    eachName = ref[i];
    if (!(eachName === 'id' || eachName === 'text')) {
      eachValue = item.getAttribute(eachName);
      if (!(eachName === 'indent' && eachValue === '1')) {
        outlineElement.attribs[eachName] = eachValue;
      }
    }
  }
  dom.appendChild(parentElement, outlineElement);
  return context.pushElement(outlineElement);
};

serializeItemBody = function(item, bodyAttributedString, options, context) {
  var outlineElement;
  outlineElement = context.topElement();
  return outlineElement.attribs['text'] = bodyAttributedString.toInlineBMLString();
};

endSerializeItem = function(item, options, context) {
  return context.popElement();
};

endSerialization = function(options, context) {
  dom.prettyDOM(context.opml, {
    p: true
  });
  return dom.getOuterHTML(context.opml, {
    decodeEntities: true,
    lowerCaseTags: true,
    xmlMode: true
  });
};


/*
Deserialization
 */

deserializeItems = function(opmlString, outline, options) {
  var bodyElement, eachOutline, flatItems, headElement, items, opmlElement, parsedDOM;
  parsedDOM = dom.parseDOM(opmlString);
  opmlElement = dom.getElementsByTagName('opml', parsedDOM, false)[0];
  if (!opmlElement) {
    throw new Error('Could not find <opml> element.');
  }
  headElement = dom.getElementsByTagName('head', opmlElement.children, false)[0];
  bodyElement = dom.getElementsByTagName('body', opmlElement.children, false)[0];
  if (bodyElement) {
    dom.normalizeDOM(bodyElement);
    flatItems = [];
    eachOutline = dom.firstChild(bodyElement);
    while (eachOutline) {
      createItem(outline, eachOutline, 0, flatItems);
      eachOutline = eachOutline.next;
    }
    items = Item.buildItemHiearchy(flatItems);
    return items;
  } else {
    throw new Error('Could not find <body> element.');
  }
};

createItem = function(outline, outlineElement, depth, flatItems, remapIDCallback) {
  var each, eachOutline, i, item, itemIndent, len, ref, results;
  assert(outlineElement.name === 'outline', "Expected OUTLINE element but got " + outlineElement.tagName);
  item = outline.createItem('', outlineElement.attribs['id']);
  item.bodyHTMLString = outlineElement.attribs['text'] || '';
  ref = Object.keys(outlineElement.attribs);
  for (i = 0, len = ref.length; i < len; i++) {
    each = ref[i];
    if (each !== 'id') {
      item.setAttribute(each, outlineElement.attribs[each]);
    }
  }
  itemIndent = item.indent || 1;
  depth = depth + itemIndent;
  item.indent = depth;
  flatItems.push(item);
  eachOutline = dom.firstChild(outlineElement);
  results = [];
  while (eachOutline) {
    createItem(outline, eachOutline, depth, flatItems, remapIDCallback);
    results.push(eachOutline = eachOutline.next);
  }
  return results;
};

module.exports = {
  beginSerialization: beginSerialization,
  beginSerializeItem: beginSerializeItem,
  serializeItemBody: serializeItemBody,
  endSerializeItem: endSerializeItem,
  endSerialization: endSerialization,
  deserializeItems: deserializeItems
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/serializations/opml.js
 ** module id = 195
 ** module chunks = 0
 **/